module.exports = __webpack_public_path__ + "media/images/goctruyen-d1d5bc2db2ffcd4e4db1de4d86f1a473.png";